import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import es from 'dayjs/locale/es';

dayjs.extend(customParseFormat);
dayjs.extend(duration);
dayjs.extend(relativeTime);
dayjs.locale(es);

export default {
  getDate(value, format = 'DD/MM/YYYY') {
    return dayjs(String(value)).format(format);
  },
  complaintAge(value) {
    const timeComplaint = dayjs(value);

    return dayjs.duration(dayjs().diff(timeComplaint)).humanize();
  },
  customFormat(value) {
    return dayjs(value, 'YYYY-MM-DD HH:mm:ss ZZ');
  },
  isAfterAWeek(value) {
    const timeComplaint = dayjs(value);
    const aWeekAfter = dayjs(timeComplaint).add(1, 'week');

    if (dayjs().isAfter(aWeekAfter)) { return true; }
    return false;
  },
  isValidDate(value) {
    if (dayjs(String(value)).isValid()) {
      return this.getDate(value, 'DD/MM/YYYY HH:mm:ss');
    }

    return '-';
  },
  isNan(value) {
    if (isNaN(dayjs().diff(dayjs(value), 'days'))) { return '-'; }

    return dayjs().diff(dayjs(value), 'days');
  },
};



// WEBPACK FOOTER //
// ./src/utils/dateService.js